import gql from 'graphql-tag';
import { gqlClient } from '../../../gql-client';
import { LaunchAppInput, LaunchMetadata } from '../../../types';

const LAUNCH_MUTATION = gql`
  mutation launchSMARTApp($input: LaunchSMARTAppInput!) {
    launchSMARTApp(input: $input) {
      smartAppUrl
    }
  }
`;

export const launchSmartApp = async (
  input: LaunchAppInput,
): Promise<LaunchMetadata | undefined> => {
  const result = await gqlClient.mutate<
    { launchSMARTApp: LaunchMetadata },
    { input: LaunchAppInput }
  >({
    mutation: LAUNCH_MUTATION,
    variables: { input },
    fetchPolicy: 'no-cache',
    context: { uri: '/prior-auth/api/graphql' },
  });

  return result?.data?.launchSMARTApp;
};
